export const GET_REGATTAS = 'Main/GET_REGATTAS';
export const GET_REGIONS = 'Main/GET_REGIONS';
export const OPEN_ACTIVE_REGATTA_PAGE = 'Main/OPEN_ACTIVE_REGATTA_PAGE';
export const REDIRECT = 'Main/REDIRECT';
export const SET_ACTIVE_REGATTA_ID = 'Main/SET_ACTIVE_REGATTA_ID';
export const SET_ACTIVE_REGION_ID = 'Main/SET_ACTIVE_REGION_ID';
export const SET_ACTIVE_REGION_SEASON_ID = 'Main/SET_ACTIVE_REGION_SEASON_ID';
export const SET_LANGUAGE = 'Main/SET_LANGUAGE';
export const SET_LAST_ACTIVE_REGATTA_ID = 'Main/SET_LAST_ACTIVE_REGATTA_ID';
export const SET_START = 'Main/SET_START';
export const SETUP_LANGUAGE = 'Main/SETUP_LANGUAGE';
export const SETUP_MAIN_DATA = 'Main/SETUP_MAIN_DATA';
export const SETUP_MENU = 'Main/SETUP_MENU';
export const SETUP_USER = 'Main/SETUP_USER';
export const TOGGLE_REGION_SELECTOR = 'Main/TOGGLE_REGION_SELECTOR';
